import React, { useState } from "react";
import CustomButton from "../common/CustomButton";
import { FiStar } from "react-icons/fi";

export default function LeaveReviewModal({
  isOpen,
  onClose,
  onSubmit,
  isSubmitting,
}) {
  const [rating, setRating] = useState(0);
  const [review, setReview] = useState("");

  if (!isOpen) return null;

  const handleSubmit = () => {
    if (rating === 0) {
      alert("Please select rating");
      return;
    }
    if (!review.trim()) {
      alert("Please enter review");
      return;
    }

    onSubmit({ rating, review });
  };

  return (
    <div
      className="fixed inset-0 bg-black/40 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-xl w-[420px] p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-lg font-semibold mb-4">Leave a Review</h2>

        {/* ⭐ Rating */}
        <div className="flex gap-2 mb-4">
          {[1, 2, 3, 4, 5].map((star) => (
            <FiStar
              key={star}
              size={28}
              onClick={() => setRating(star)}
              className={`cursor-pointer ${
                star <= rating
                  ? "text-yellow-400 fill-yellow-400"
                  : "text-gray-300"
              }`}
            />
          ))}
        </div>

        {/* ✍️ Review */}
        <textarea
          rows={4}
          placeholder="Write your review..."
          value={review}
          onChange={(e) => setReview(e.target.value)}
          className="w-full border rounded-lg p-3 resize-none"
        />

        {/* Buttons */}
        <div className="flex justify-end gap-3 mt-6">
          <CustomButton variant="secondary" onClick={onClose}>
            Cancel
          </CustomButton>

          <CustomButton
            variant="primary"
            loading={isSubmitting}
            onClick={handleSubmit}
          >
            Submit Review
          </CustomButton>
        </div>
      </div>
    </div>
  );
}
